module.exports = {"data":{"markdownRemark":{"id":"/opt/build/repo/src/pages/test.md absPath of file >>> MarkdownRemark","html":"<p>test</p>","fields":{"slug":"/test/"},"frontmatter":{"date":"April 06, 2018","title":"test","cover":"/img/coffee-gear.png","meta_title":"test","meta_description":"test","username":"test","tags":["test"]}}},"pathContext":{"id":"/opt/build/repo/src/pages/test.md absPath of file >>> MarkdownRemark"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/test.json
// module id = 441
// module chunks = 89450997894629